import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { EnvironmentService } from "../../../snatch/services";
import { Select, Store } from "@ngxs/store";
import { AuthTokenState } from "../../../auth/state/auth-token.state";
import { Observable } from "rxjs";
import { CheckDMConversation } from "../../../inbox/state/inbox.state";
export class MainDetailsComponent {
    constructor(fb, chgRef, envService, store) {
        this.fb = fb;
        this.chgRef = chgRef;
        this.envService = envService;
        this.store = store;
        this.deliveryFormatLabel = 'Course';
    }
    ngOnChanges(changes) {
        const { selectedVariant } = changes;
        if (selectedVariant) {
            const newImageUrl = (this.selectedVariant.renders.length && this.selectedVariant.renders[0].mediumImageUri ? this.selectedVariant.renders[0].mediumImageUri : null);
            if (newImageUrl && (this.imageUrl !== newImageUrl)) {
                this.imageUrl = newImageUrl;
                this.imageLoading = true;
            }
        }
    }
    ngOnInit() {
        if (this.deliveryFormats && this.deliveryFormats.length > 0) {
            this.deliveryFormats.forEach((it) => {
                if (it.configKey === "product-assessment")
                    this.type = 'Assessment';
                if (this.envService.isQA || this.envService.isPreview || this.envService.isProdin) {
                    this.setDeliveryFormatLabel(it.configKey);
                }
            });
        }
    }
    contactSeller() {
        this.store.dispatch(new CheckDMConversation(this.seller.name));
    }
    setDeliveryFormatLabel(type) {
        switch (type) {
            case 'diagnostics':
                this.deliveryFormatLabel = 'Diagnostic';
                this.type = 'Diagnostic';
                break;
            case 'product-assessment':
                this.deliveryFormatLabel = 'Assessment';
                break;
            case 'lab':
                this.deliveryFormatLabel = 'vLab';
                this.type = 'vLab';
                break;
            default:
                this.deliveryFormatLabel = 'Course';
        }
    }
}
tslib_1.__decorate([
    Select(AuthTokenState.isLogged),
    tslib_1.__metadata("design:type", Observable)
], MainDetailsComponent.prototype, "isLogged$", void 0);
